module.exports = __webpack_public_path__ + "media/images/vedett_allatok/vedett7-ae8d259150fcfe71e873e508d00f5182.jpg";